import { Detector } from "./detector";
import storage from "../../storage/storage";
import { StorageKey } from "../../storage/storage-key";

export class LocalStorageDetector extends Detector {
  public detect(): string | undefined {
    return storage.get(StorageKey.Locale);
  }
}
